/*
* Project: LegalPlace assistant
* File: src/logic/re_index.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/

import LpOutput from './preview_render/angular_reader';
import { lpIdGetPure } from './global_getter';
import { getOFirstMultipleParent } from '../redux/reducers/load_ovc';
import lpApp from '../app/lp_app';
import ConditionsEvo from './condition_evo';

let optionsIndex = {};
let flatIndex = {};
let varsIndex = {};
const multiplesIndex = {};
const varViewIndex = {};
const multipleList = {};

// optimization issue
const conditionList = {};

let parentingIndex = {};
const parentingIndexOpts = {};

function initializeOptions() {
  optionsIndex = {};
}

function initializeVariables() {
  varsIndex = {};
}

function initializeIndexes() {
  flatIndex = {};
  parentingIndex = {};
}

function lpUpdateMultiple(opt, m) {
  multipleList[opt] = m;
  window.lp_mList = multipleList;
}

function lpGetMultipleList(opt) {
  return multipleList[opt];
}

function updateConditions() {
  let keys;
  if (!lpApp.references.options) return;
  const la = lpApp.action_tracker.last_action;
  const laArg = lpApp.action_tracker.la_arg1;
  if (la === 'EDIT_OPTION_RADIO_'
        || la === 'SET_SECTION_ID'
        || la === 'EDIT_OPTION_VALUE_'
        || la === 'ADD_MULTIPLE'
        || la === 'REMOVE_FIRST'
        || la === 'REMOVE_FIRST_VARIABLE'
        || la === 'REM_OPTION_DUP'
        || la === 'REM_VARIABLE_DUP'
        || la === 'EDIT_VARIABLE'
  ) {
    if (la === 'EDIT_VARIABLE') keys = lpApp.indexes.dependencies.getVariableDependecies(lpIdGetPure(laArg));
    else keys = lpApp.indexes.dependencies.getDependecies(lpIdGetPure(laArg));
    if (keys) {
      keys.forEach((idx) => {
        const now = lpApp.references.getOption(idx).meta;
        if (now.conditional && (now.compiledConditions.length > 0)) {
          // let c = new ConditionRuntime(now.compiledConditions);
          // c.compileDirect()
          // conditionList[idx] = c.execute(true);

          conditionList[idx] = ConditionsEvo.getCondition(idx);
        }
      });
    }
    // debugger;


    lpApp.indexes.conditions.buildConditions(conditionList);
  }
  return conditionList;
}

window.updateConditions = updateConditions;
function reorderViews(views) {
  Object.keys(views).forEach((idx) => {
    const id = parseInt(idx.split('.')[0], 10);
    const meView = new LpOutput(id, views[idx]);
    meView.compile();
    // FIXME:
    meView.variables.forEach((jdx) => {
      if (varViewIndex[jdx]) varViewIndex[jdx].push(idx);
      else varViewIndex[jdx] = [idx];
    });
  });
  // window.ous = varViewIndex;
  lpApp.indexes.updateV2V(varViewIndex);
}
function reorderMultiples(opt) {
  let cId = opt.id;
  if (typeof opt.id === 'string') {
    [cId] = opt.id.split('_');
    {
      const ids = getOFirstMultipleParent(cId);
      // console.log(ids)
      multiplesIndex[ids] = true;
    }
  } else multiplesIndex[cId] = false;
}

function reorderOption(opt, i = 0) {
  if (opt) {
    optionsIndex[opt.id] = { value: opt.value, key: opt.key, index: i };
    lpApp.indexes.updateOption(opt, i);
  }
}

function reorederFlat(flat) {
  if (flat) {
    flatIndex[flat.uiid] = {
      id: flat.id,
      parent: flat.parentId,
      ovc: flat.genre,
      parentUi: flat.parentUi,
      active: flat.active,
    };
  }
}

function reorderVariable(var_, i = 0) {
  if (var_) {
    varsIndex[var_.id] = { value: var_.value, key: var_.key, index: i };
    lpApp.indexes.updateVariable(var_, i);
    window.vars = varsIndex;
  }
}


function reorderParent(flat) {
  if (flat) {
    if (flat.genre === 'oc' || flat.genre === 'vc') return;
    if (flat.genre === 'o') {
      parentingIndexOpts[flat.id] = {
        ovc: flat.genre,
        parent: flat.parentId,
        section: flat.sectionId,
      };
    } else {
      parentingIndex[flat.id] = {
        ovc: flat.genre,
        parent: flat.parentId,
        section: flat.sectionId,
      };
    }
  }
}

function updateWindow() {
  window.lp_ops = optionsIndex;
  window.lp_vars = varsIndex;
  window.lp_parenting = parentingIndex;
  window.lp_parenting_opts = parentingIndexOpts;
  window.lp_flat = flatIndex;
  // window.lp_mult = {};//multiplesIndex;
  // window.lp_co = conditionList;
}

// get information:
function lpGetOptionById(id) {
  return optionsIndex[id];
}

function lpGetFlatById(uiid) {
  return flatIndex[uiid];
}
function lpGetVariableById(id) {
  return varsIndex[id];
}
function lpSetVariableById(id, value) {
  varsIndex[id].value = value;
}

function lpGetIsMultiple(id) {
  // console.log(id)
  if (lpApp.indexes.multiples.getMultiple(id)) return lpApp.indexes.multiples.getMultiple(id);
  return undefined;
}

function lpGetViewByVariable(id) {
  let result = [];
  // console.group(id);
  //     console.log(varViewIndex[id]);
  // console.groupEnd(id);
  if (lpApp.indexes.content.content) {
    lpApp.indexes.content.content.forEach((idx) => {
      if (varViewIndex) {
        varViewIndex[id].forEach((jdx) => {
          if (jdx === idx[0]) result = [jdx];
        });
      }
    });
  }
  return result;
}
function lpGetParentById(id) {
  return parentingIndex[id];
}

/*
 * Delete functions
 */
function delReindexVariable(id) {
  if (Object.prototype.hasOwnProperty.call(varsIndex, id)) delete varsIndex[id];
}
function delReindexOption(id) {
  if (Object.prototype.hasOwnProperty.call(varsIndex, id)) delete optionsIndex[id];
}


export {
  initializeIndexes,
  initializeOptions,
  reorderOption,
  reorederFlat,
  reorderVariable,
  reorderMultiples,
  reorderParent,
  reorderViews,
  lpUpdateMultiple,
  lpGetMultipleList,
  initializeVariables,
  // the next line is for debugging
  updateWindow,
  // those are for getting info, and imported into options
  lpGetOptionById,
  lpGetFlatById,
  lpGetVariableById,
  lpGetIsMultiple,
  lpGetViewByVariable,
  lpGetParentById,
  lpSetVariableById,
  updateConditions,
  delReindexVariable,
  delReindexOption,
};



// WEBPACK FOOTER //
// ./src/logic/re_index.js